var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAccessGit)?_c('span',{staticClass:"owal git info",on:{"dblclick":function($event){_vm.showFull = !_vm.showFull}}},[_vm._v(" "+_vm._s(this.gitInfo)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }